"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _types = require("./types");
var _logger = require("@studio/logger");
var LOGGER_NAME = 'handleVideoInputChanged';

/**
 * Handles the change event when the video input device is changed.
 *
 * @param {Array} deviceList - The list of available video input devices.
 * @returns {Function} - A Redux thunk function.
 */
function handleVideoInputChanged() {
  var deviceList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var setDesiredAttendeeCameraStatus = arguments.length > 1 ? arguments[1] : undefined;
  return function (dispatch, getState) {
    var _attendeeResponse$Att, _videoInputDevice$dev;
    var _getState = getState(),
      attendeeCameraStatus = _getState.attendeeCameraStatus,
      videoInputDevice = _getState.videoInputDevice,
      attendeeResponse = _getState.meeting.attendeeResponse;
    var attendeeId = attendeeResponse === null || attendeeResponse === void 0 || (_attendeeResponse$Att = attendeeResponse.Attendee) === null || _attendeeResponse$Att === void 0 ? void 0 : _attendeeResponse$Att.AttendeeId;
    var isAttendeeCameraOn = attendeeCameraStatus[attendeeId];
    var videoInput = (_videoInputDevice$dev = videoInputDevice.device) !== null && _videoInputDevice$dev !== void 0 ? _videoInputDevice$dev : videoInputDevice;
    var isVideoDeviceStillConnected = deviceList.find(function (device) {
      return device.deviceId === videoInput;
    });
    if (!isVideoDeviceStillConnected && isAttendeeCameraOn) {
      var logPayload = {
        videoInputDevice: videoInputDevice,
        attendeeId: attendeeId,
        title: "The video device ".concat(videoInput, " of Attendee ").concat(attendeeId, " has been disconnected.")
      };
      (0, _logger.sendToDatadog)(LOGGER_NAME, logPayload, logPayload.title, false);
      console.log(logPayload.title);
      var action = {
        type: _types.VIDEO_DEVICE_LOST,
        payload: true
      };
      dispatch(action);
      dispatch(setDesiredAttendeeCameraStatus(attendeeId, false));
    }
  };
}
var _default = exports["default"] = handleVideoInputChanged;